// auth.service.ts (resumen)
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  public cancelPendingRequests$ = new Subject<void>();
  private _currentSession = new BehaviorSubject<any>(null);
  public currentSession$ = this._currentSession.asObservable();
  public isLoggingOut = false;
  private readonly KEYS = ['KSI', 'sesionPocae', 'name', 'nombre', 'idEmpresa', 'idUsuario'];

  constructor(private router: Router) {}

  setCurrentSession(session: any) {
    this._currentSession.next(session);
  }

  logout(redirect: boolean = true) {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    localStorage.setItem('loggingOut', '1');
    this.cancelPendingRequests$.next();

    setTimeout(() => {
      for (const k of this.KEYS) localStorage.removeItem(k);
      this._currentSession.next(null);
      localStorage.removeItem('loggingOut');
      if (redirect) this.router.navigate(['/']);
      this.isLoggingOut = false;
    }, 80);
  }
}
